import React, { useState, useEffect } from 'react';
import { ReactComponent as BabysFYLabel } from 'babys-first-year/assets/babyyearbookslabel.svg';
import { Box, Flex, Image } from 'rebass';
import { keyframes } from '@emotion/react';
import { useWindowSize } from 'react-use';
import EditRemindersBg from './assets/EditRemindersBg.png';
import NotificationSettings, { label } from 'members/profile/notification-settings';

const rotate = keyframes`
  0% { transform: translateX(100%); }
  100% { transform: translateX(0);  }
`;

const EditReminders = ({ child_journal_id, secret, onStepDown }) => {
    const [animationStyle, setAnimationStyle] = useState({});
    const { width } = useWindowSize();

    const animateElement = () => {
        setAnimationStyle((prevStyle) => ({
            ...prevStyle,
            opacity: 0,
            animation: 'unset',
        }));

        setTimeout(() => {
            setAnimationStyle((prevStyle) => ({
                ...prevStyle,
                opacity: 1,
                animation: `${rotate} 1s ease`,
            }));
        }, 500);
    };

    useEffect(() => {
        animateElement()
    }, [])

    return (
        <Flex bg="white" width="100%" flexDirection={width < 600 ? 'column' : 'row'} height={'100vh'} sx={{ position: width < 600 ? 'unset' : 'fixed' }}>
            {width > 600 && <Flex bg="#E0FFED" width={["100%", "30%", "30%"]} minWidth={400} >
                <Image src={EditRemindersBg} mx="auto" minHeight={500} />
            </Flex>}
            <Flex
                sx={animationStyle}
                maxWidth={700}
                mx="auto"
                flexDirection="column"
                width={width < 600 ? "100%" : "calc(100vw - 30%)"}
                px={2}
                height={'100vh'} overflowY="auto"
                bg="white"
            >
                <Box my={3} mx="auto">
                    <BabysFYLabel />
                </Box>
                <NotificationSettings onStepDown={onStepDown} secret={secret} child_journal_id={child_journal_id} isFromPublic />
            </Flex>
        </Flex >
    )
};

export default EditReminders;
